import { ScopeDynamicFieldSettingModel } from '@app/features/scoping/models/scope-dynamic-field-setting.model'

export const getDynamicFieldDropdownSettingsWithOptions = (settings: ScopeDynamicFieldSettingModel[]) =>
  settings.reduce(
    (arr, setting) => [
      ...arr,
      {
        setting,
        options:
          setting.value
            ?.split('\n')
            .filter((option) => option.trim())
            .map((option) => ({ name: option })) || [],
      },
    ],
    []
  )
